import { AppDispatch, RootState } from "../store";
import { uiActions } from "../slices/ui";

export const toggleSidebar =
  () =>
  (dispatch: AppDispatch, getState: () => RootState): void => {
    const { isSidebarCollapsed } = getState().ui;
    dispatch(uiActions.setSidebarCollapsed(!isSidebarCollapsed));
  };

export const setSidebarState =
  (isCollapsed: boolean) =>
  (dispatch: AppDispatch): void => {
    dispatch(uiActions.setSidebarCollapsed(isCollapsed));
  };
